import { LoadingIndicator } from "@components";
import { Grid } from "@components/Grid";
import type { EnrichedPassiveDns } from "@modules/network/@types/Domain";
import { schema } from "./schema";

type Props = {
  data: Array<EnrichedPassiveDns>;
  isLoading: boolean;
};

const PassiveDnsTable = ({ data, isLoading }: Props) => (
  <Grid
    testId="domain-passive-dns-table"
    showLoading={isLoading}
    LoadingComponent={<LoadingIndicator style={{ margin: "5rem 0" }} />}
    data={data}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schema={schema as any}
  />
);

export default PassiveDnsTable;
